import { render, staticRenderFns } from "./PluginUpload.vue?vue&type=template&id=5ce0184f&scoped=true&"
import script from "./PluginUpload.vue?vue&type=script&lang=js&"
export * from "./PluginUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce0184f",
  null
  
)

export default component.exports